import $ from "jquery";

export class ExpandContentModule {

    constructor() {
        this.blockSelector = '.read-more-block';
        this.buttonSelector = '[data-read-more-trigger]';
        this.hiddenSelector = '[data-read-more-action]';

        $(this.buttonSelector).on('click', (e) => { this.handleClick(e) });
    }

    handleClick(e) {
        e.stopImmediatePropagation();

        const $currentEl = $(e.currentTarget);
        const $block = $currentEl.closest(this.blockSelector)
        const $hiddenContent = $block.find(this.hiddenSelector);

        if (this.isExpanded($hiddenContent)) {
            this.closeExpandedContent($block, $hiddenContent);
        } else {
            this.openExpandedContent($block, $hiddenContent);
        }
    }

    isExpanded($el) {
        return $el.hasClass('active');
    }

    closeExpandedContent($block, $hiddenContent) {
        this.toggleButtons($block, 'inactive');
        $hiddenContent.removeClass('active');
        $hiddenContent.slideUp(750);

        const yPos = $block.offset().top;
        this.scrollToPosition(parseInt(yPos), 750);
    }

    openExpandedContent($block, $hiddenContent) {
        this.toggleButtons($block, 'active');
        $hiddenContent.addClass('active');
        $hiddenContent.slideDown(500);

        const yPos = $hiddenContent.offset().top;
        const marginTop = window.innerWidth < 767 ? 100 : 100; /* possibly changed in mediaquery later on. */

        this.scrollToPosition(parseInt(yPos + marginTop), 500);
    }

    toggleButtons($block, state) {
        const $buttons = $block.find(this.buttonSelector);
        const dataSelector = state == 'active' ? 'active-text' : 'inactive-text';
        const imgDataSelector = state == 'active' ? 'active-image' : 'inactive-image';

        $buttons.each(function() {
            let $el = $(this);
            $el.find('span').text($el.data(dataSelector));

            let $img = $el.find('img');
            $img.attr('src', $img.data(imgDataSelector));
        });
    }

    scrollToPosition(positionY, duration) { 
        $('html, body').animate({
            scrollTop: positionY
        }, duration);
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/lynx-hedge/assets/scripts/src/App/ExpandContentModule.js